// extracted by mini-css-extract-plugin
export default {"container":"message_container__irfFU","message":"message_message__ZYGuh","text":"message_text__U40VX"};